module.exports = __webpack_public_path__ + "img/ch-stationary2-res.1bc36b64.jpg";